/**
 * OGTags — injects dynamic Open Graph + Twitter meta tags + canonical link.
 * Use on public surfaces so social shares render premium preview cards.
 *
 * Drop into the page top: <OGTags title="..." description="..." image="..." />
 */
import { useEffect } from "react";

function upsert(tag, attrs) {
  let el = document.head.querySelector(tag + Object.entries(attrs).filter(([k]) => k !== "content").map(([k, v]) => `[${k}="${v}"]`).join(""));
  if (!el) {
    el = document.createElement(tag.replace(/\[.*\]/, ""));
    Object.entries(attrs).forEach(([k, v]) => k !== "content" && el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  if (attrs.content !== undefined) el.setAttribute("content", attrs.content);
  return el;
}

export default function OGTags({ title, description, image, url, type = "profile" }) {
  useEffect(() => {
    const originalTitle = document.title;
    if (title) document.title = `${title} · TeeBee`;

    const meta = [
      { tag: "meta", attrs: { property: "og:title",       content: title } },
      { tag: "meta", attrs: { property: "og:description", content: description } },
      { tag: "meta", attrs: { property: "og:image",       content: image } },
      { tag: "meta", attrs: { property: "og:url",         content: url || window.location.href } },
      { tag: "meta", attrs: { property: "og:type",        content: type } },
      { tag: "meta", attrs: { name: "twitter:card",       content: "summary_large_image" } },
      { tag: "meta", attrs: { name: "twitter:title",      content: title } },
      { tag: "meta", attrs: { name: "twitter:description", content: description } },
      { tag: "meta", attrs: { name: "twitter:image",      content: image } },
      { tag: "meta", attrs: { name: "description",        content: description } },
    ];
    const created = meta.filter((m) => m.attrs.content).map((m) => upsert(m.tag, m.attrs));

    return () => {
      // Don't yank tags off — they help the rest of the SPA session, but DO restore title.
      document.title = originalTitle;
    };
  }, [title, description, image, url, type]);

  return null;
}
